import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfigService } from '../app-config.service';


@Injectable({
    providedIn: 'root'
})

export class ConfigurationService {

    private URL = '';

    constructor(private http: HttpClient, private configService: AppConfigService) {
        this.URL = this.configService.getConfig().urlServiceConfiguration;
    }

    getParamMaintenance() {
        console.log('new object in request Configuration /getParamMaintenance -> ');
        return this.http.get(`${this.URL}/getParamMaintenance`);
    }

    getTextMaintenance() {
        console.log('new object in request Configuration /getTextMaintenance -> ');
        return this.http.get(`${this.URL}/getTextMaintenance`);
    }

}
